<template>
  <div>

    <div :class="{ 'show': toggleModal }" class="modal fade" style="height: 100vh">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom">
            <h5 class="modal-title h4">
              Add Appointment
              <!-- <small class="m-0 text-muted">{{ $t('subMenu.salon_menu_product') }} - "{{ sTitle }}"</small> -->
            </h5>
            <button type="button" class="close" @click="toggleModal = false">
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">

              <div class="col-12 col-md">

                <div class="form-group">
                  <label class="h5">Outlet</label>
                  <multiselect
                    v-model="appointmentForm.outlet"
                    label="text"
                    track-by="id"
                    :options="outlets"
                    placeholder="Select Outlet"
                    :searchable="true"
                    :show-labels="false"
                    :allow-empty="false"
                    openDirection="below"
                    @select="outletSelect"
                    :disabled="this.appointmentForm.dataID ? true : false"
                    class="w-100">
                    <template slot="option" slot-scope="{ option }">
                      {{
                        option.text
                      }}
                    </template>
                    <span slot="noResult">
                      {{
                        $t("table.no_records")
                      }}
                    </span>
                  </multiselect>
                </div>

                <div class="form-group member-input">
                  <label class="h5">Mobile</label>
                  <multiselect
                    ref="member-input"
                    v-model="appointmentForm.member"
                    placeholder="Select/Create member"
                    tag-placeholder="Enter to create new member"
                    label="mobile"
                    track-by="mobile"
                    :options="members"
                    :multiple="false"
                    :taggable="true"
                    :allow-empty="false"
                    selectLabel=""
                    selectedLabel=""
                    :custom-label="mobileWithName"
                    :disabled="this.appointmentForm.dataID ? true : false"
                    :preserveSearch="true"
                    :preserve-search="true"
                    @input="onMemberSelect"
                    @search-change="onMemberInput"
                    @open="onMemberOpen"
                    @close="onMemberClose"
                    @tag="onMemberTag">
                    <template slot="singleLabel" slot-scope="{ option }">
                      {{ option.mobile }}
                    </template>
                  </multiselect>
                  <span class="text-danger" v-show="maxCharLimit">
                    8 digit max. (exclude country code)
                  </span>
                </div>

                <div class="form-group">
                  <label class="h5">Name</label>
                  <b-form-input
                    :placeholder="addFlag ? 'Enter New Member Name' : ''"
                    :disabled="this.appointmentForm.dataID ? true : false"
                    v-model="appointmentForm.member.name">
                  </b-form-input>
                </div>

                <div class="form-group">
                  <label class="h5">Staff</label>
                  <b-overlay :show="staffSpinner && !appointmentForm.dataID" rounded="sm">
                    <b-input-group>
                      <b-form-input
                        type="search"
                        @input="searchStaff"
                        v-model="searchThatStaff"
                        :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false"
                        placeholder="Search Staff"></b-form-input>
                    </b-input-group>
                    <div
                      class="w-100 row">
                      <div
                        v-for="(s, index) in staffs"
                        :key="index"
                        class="col-6 col-sm-4 col-md-3 text-center pt-3"
                        size="xs"
                        :class="appointmentForm.staff === s ? 'active' : ''"
                        @click="selectStaff(s)">
                        <b-avatar
                          :src="s.image != '' ? s.image : s.icon"
                          size="4rem">
                          <template v-if="appointmentForm.staff && s ? appointmentForm.staff['staffID'] === s['staffID'] : false" #badge>
                            <b-icon icon="check"></b-icon>
                          </template>
                        </b-avatar>
                        <br>
                        {{ s.name }}
                      </div>
                    </div>
                  </b-overlay>
                </div>

              </div>

              <div class="d-none d-md-block col-auto border-right"></div>
              <div class="d-none d-md-block col-auto"></div>

              <div class="col-12 col-md">

                <div class="form-group">
                  <label class="h5">Date</label>
                  <!-- <b-form-input :disabled="appointmentForm.staff == null" v-model="appointmentForm.arrivalDate" @input="loadStaffAvailableTime" :min="minDate" type="date"></b-form-input> -->
                  <b-form-datepicker
                    :disabled="forceDisable || appointmentForm.staff == null || (appointmentForm.noshowDate || appointmentForm.completedDate ? true : false)"
                    id="appointment-datepicker"
                    :min="minDate"
                    v-model="appointmentForm.arrivalDate"
                    @input="loadStaffAvailableTime"
                    class="mb-2">
                  </b-form-datepicker>
                </div>

                <div class="form-group">
                  <label class="h5">Time</label>
                  <b-overlay :show="timeSpinner && !initialLoadTime">
                    <b-form-select
                      :disabled="forceDisable || appointmentForm.arrivalDate == null || (appointmentForm.noshowDate || appointmentForm.completedDate ? true : false)"
                      v-model="appointmentForm.time"
                      :options="timeOptions.length === 0 ? timeOptionsClone : timeOptions">
                    </b-form-select>
                  </b-overlay>
                </div>

                <div class="form-group">
                  <label class="h5">Service</label>
                  <multiselect
                    v-model="appointmentForm.sku"
                    placeholder="Select Service"
                    label="name"
                    track-by="skuID"
                    :multiple="false"
                    :options="skuList"
                    :searchable="true"
                    :show-labels="false"
                    :allow-empty="false"
                    @select="selectSku"
                    openDirection="below"
                    :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false"
                    class="w-100">
                    <template slot="option" slot-scope="{ option }">{{
                      option.name
                    }}</template>
                    <span slot="noResult">{{ $t("table.no_records") }}</span>
                  </multiselect>
                </div>

                <div class="form-group">
                  <label class="h5">Duration</label>
                  <b-form-select
                    v-model="appointmentForm.duration"
                    :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false">
                    <b-form-select-option :value="null" disabled>Select Duration</b-form-select-option>
                    <b-form-select-option
                      v-for="(d, index) in durationList"
                      :key="index"
                      :value="d">{{ d.text }}</b-form-select-option>
                  </b-form-select>
                </div>

                <div class="form-group">
                  <label class="h5">Remarks</label>
                  <textarea
                    v-model="appointmentForm.remarks"
                    :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false"
                    class="form-control"
                    cols="1"
                    rows="5"></textarea>
                </div>

                <div class="row">

                  <div class="col-6 form-group">
                    <label class="h5">Color</label>
                    <div>
                      <button
                        :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false"
                        size="sm"
                        id="popover-color-list"
                        class="btn rounded-pill"
                        :class="appointmentForm.color.color == 'White'
                          ? 'text-dark'
                          : 'text-light'
                          "
                        :style="`background-color:${appointmentForm.color.hex};border-color:${appointmentForm.color.hex};`">
                        {{ appointmentForm.color.color }}
                      </button>
                      <b-popover
                        ref="popover-color"
                        target="popover-color-list"
                        triggers="click blur"
                        boundary="window"
                        placement="righttop">
                        <div class="d-flex flex-wrap justify-content-center p-2" style="max-width: 330px">
                          <a
                            v-for="(c, index) in colorList"
                            @click="(appointmentForm.color = c); $refs['popover-color'].$emit('close')"
                            :key="index"
                            :class="c.color == 'White'
                              ? 'text-dark'
                              : 'text-light'
                              "
                            :style="`background-color:${c.hex}`"
                            class="boxColor link m-2">{{ c.color }}</a>
                        </div>
                      </b-popover>
                    </div>
                  </div>

                  <div class="col-6 form-group">
                    <label class="h5">Block Time</label>
                    <b-form-checkbox
                      v-model="appointmentForm.blocked"
                      :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false"
                      switch
                      size="lg">
                    </b-form-checkbox>
                  </div>

                </div>

                <div class="form-group">
                  <label class="h5">Reminder</label>
                  <select
                    :disabled="forceDisable || appointmentForm.noshowDate || appointmentForm.completedDate ? true : false"
                    v-model="appointmentForm.reminderTypeID"
                    class="form-control">
                    <option value="0">No Reminder</option>
                    <option value="1">Same Day</option>
                    <option value="2">1 Day Before</option>
                    <option value="3">2 Day Before</option>
                  </select>
                </div>

              </div>

            </div>
          </div>
          <div class="modal-footer">
            <div class="row w-100 no-gutters">

              <div v-if="appointmentForm.dataID" class="col-auto">
                <button
                  v-if="appointmentForm.noshowDate === 0 && appointmentForm.completedDate === 0"
                  class="btn btn-danger waves-effect waves-themed mr-2"
                  @click="emitDetail(appointmentForm.dataID, 'delete')">
                  Delete <b-icon icon="trash"></b-icon>
                </button>

                <button
                  v-if="appointmentForm.noshowDate === 0 && appointmentForm.completedDate === 0"
                  class="btn btn-warning waves-effect waves-themed mr-2"
                  @click="emitDetail(appointmentForm.dataID, 'noshow')">
                  No Show <i class="fa fa-times-circle fs-xl"></i>
                </button>

                <button
                  v-if="appointmentForm.noshowDate === 0 && appointmentForm.completedDate === 0"
                  class="btn btn-success waves-effect waves-themed mr-2"
                  @click="emitDetail(appointmentForm.dataID, 'completed')">
                  Completed <i class="fa fa-check-circle fs-xl"></i>
                </button>

              </div>

              <div class="col">
              </div>

              <div class="col-auto">
                <button
                  type="button"
                  class="btn btn-secondary waves-effect waves-themed ml-2"
                  @click="toggleModal = false">
                  {{ $t('button_link.cancel') }}
                </button>

                <!-- <button
                  type="button"
                  class="btn btn-primary waves-effect waves-themed ml-2"
                  @click="onPopupSave"
                  :disabled="saveable">
                  Save
                </button> -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="{ 'show': toggleModalSummary }" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-bottom">
            <h5 class="modal-title h4">
              Appointment Summary
            </h5>
            <button type="button" class="close" @click="toggleModalSummary = false">
              <span aria-hidden="true"><i class="fal fa-times"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column w-100">
              <div class="d-flex flex-column mb-3">
                <label>Outlet</label>
                <b>{{ appointmentForm.outlet != null ? appointmentForm.outlet.bizName : "-" }}</b>
              </div>
              <div class="d-flex flex-column mb-3">
                <label>Member Info</label>
                <b>
                  {{ appointmentForm.member != null ? appointmentForm.member.mobile : "-" }}
                  ({{ appointmentForm.member != null ? appointmentForm.member.name : "" }})
                </b>
              </div>
              <div class="d-flex flex-column mb-3">
                <label>Date & Time</label>
                <b>{{ combineDateTime }}</b>
              </div>
              <div class="d-flex flex-column mb-3">
                <label>Staff</label>
                <b>{{ appointmentForm.staff != null ? appointmentForm.staff.name : "-" }} </b>
              </div>
              <div class="d-flex flex-column mb-3">
                <label>Service & Duration</label>
                <b>{{ appointmentForm.sku != null ? appointmentForm.sku.name : "-" }} ({{ appointmentForm.duration != null ?
                  appointmentForm.duration.text : "" }})</b>
              </div>
              <div class="d-flex flex-column mb-3">
                <label>Remarks</label>
                <b>{{ appointmentForm.remarks === "" ? "-" : appointmentForm.remarks }}</b>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary waves-effect waves-themed"
              @click="toggleModalSummary = false">
              {{ $t('button_link.cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary waves-effect waves-themed"
              @click="createAppt">
              {{ $t('button_link.yes') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import {
  handleSessionExpired,
  idbOpen,
  toastrExe,
  getMemberMap,
} from "../../../../assets/js/dashboard/dashboard";
import { vMaska } from "maska";
import moment from "moment";
import {contactValidation} from './../../../../assets/js/dashboard/utilities'
export default {
  name: "AddAppointmentModal",
  props: {
    sku: Array,
    selectedOutlet: Object,
    selectedDate: Date,
    selectedStaff: Number,
    COLOR_CONST_RAW: Array,
  },
  directives: { maska: vMaska },
  watch: {
    sku() {
      this.skuList = this.$props.sku;
    },
    selected() {
      this.appointmentForm.outlet = this.$props.selected;
      this.outletSelect(this.appointmentForm.outlet);
    },
    selectedDate() {
      this.loadStaffAvailableTime(moment(this.$props.selectedDate).format("YYYY-MM-DD"));
      this.appointmentForm.time = moment(this.$props.selectedDate).format("HH:mm");
    },
    selectedStaff() {
      if (this.$props.selectedStaff !== 0)
        this.appointmentForm.staff = this.staffsClone.find(s => s.staffID == this.$props.selectedStaff);
      else
        this.appointmentForm.staff = this.staffsClone[0];

      this.searchThatStaff = this.appointmentForm.staff.name;
      this.loadStaffAvailableTime(moment(this.$props.selectedDate).format("YYYY-MM-DD"));
      this.appointmentForm.time = moment(this.$props.selectedDate).format("HH:mm");
    },
  },
  data() {
    return {
      toggleModal: false,
      toggleModalSummary: false,

      appointmentForm: {
        dataID: null,
        outlet: null,
        arrivalDate: null,
        time: null,
        staff: null,
        staffName: null,
        staffError: '',
        member: {
          name: "",
          mobile: "",
        },
        sku: null,
        color: {
          hex: "",
          color: "",
        },
        blocked: false,
        duration: null,
        remarks: "",

        arrivalMoment: null,
        reminderTypeID: 0,
      },
      preselectTimeSlot: '',

      outlets: [],
      timeSlots: [],
      staffs: [],
      staffsClone: [],
      staffsOutletClone: [],
      skuList: [],
      colorList: [],
      bookHours: [],
      toggle: false,
      db: null,
      members: [],
      memberMobileMap: {},
      addFlag: false,
      staffSpinner: false,
      timeSpinner: false,
      maxCharLimit: false,
      searchThatStaff: "",

      timeOptions: [],
      timeOptionsClone: [],
      initialLoadTime: false,

      forceDisable: true,
    };
  },
  methods: {
    formatDate(date, format) {
      let formattedDate = moment(date).format(format);
      if (formattedDate == "Invalid date") {
        return "-";
      } else {
        return formattedDate;
      }
    },
    mobileWithName({ mobile, name }) {
      return `${mobile} — ${name === '' ? mobile : name}`;
    },
    emitCheckDate(date) {
      let arrival = new Date(date).getTime();
      let now = new Date().getTime();
      if (arrival <= now) {
        return true;
      }
      else {
        return false;
      }
    },

    async show(data, date, staffID, outletID) {
      this.timeOptions = [];
      this.timeOptionsClone = [];

      if (data) {
        this.appointmentForm.dataID = data.bookID
        this.appointmentForm.member.name = data.member.name
        this.appointmentForm.member.mobile = data.member.mobile

        this.appointmentForm.arrivalMoment = data['arrivalDate']
        this.appointmentForm.arrivalDate = data['arrivalDate'].format('YYYY-MM-DD')
        this.timeOptions.push(data['arrivalDate'].format('HH:mm'))
        this.timeOptionsClone.push(data['arrivalDate'].format('HH:mm'))
        this.initialLoadTime = true
        this.loadStaffAvailableTime()
        this.appointmentForm.time = data['arrivalDate'].format('HH:mm')

        this.appointmentForm.sku = this.skuList.find(k => k['skuID'] === data['sku']['skuID'])
        this.appointmentForm.duration = this.durationList.find(k => k['value'] === data['duration'])

        this.appointmentForm.remarks = data['remarks']['remarks']
        this.appointmentForm.blocked = data['blocked'] ? true : false

        this.appointmentForm.color = this.colorList.find(k => k['colorID'] === data['colorID'])

        this.appointmentForm.noshowDate = data['noshowDate']
        this.appointmentForm.completedDate = data['completedDate']

        this.appointmentForm.reminderTypeID = data['reminderTypeID']

        for (let outlet of this.outlets) {
          if (outlet['id'] === data['outletID']) {
            this.appointmentForm.outlet = outlet
          }
        }

        this.outletSelect(this.appointmentForm.outlet, true)

        await this.getStaffList(data.staff.staffID)
        for (let staff of this.staffs) {
          if (staff['staffID'] === data.staff.staffID) {
            this.appointmentForm.staff = staff
            this.searchThatStaff = staff['name'];
          }
        }

        this.toggleModal = true

        return
      }

      this.appointmentForm.dataID = null

      let saved = localStorage.getItem('appointment-member')
      this.$refs['member-input'].search = saved ? saved : '6'
      this.appointmentForm.member.mobile = saved ? saved : '6'
      this.appointmentForm.member.name = ''

      if (date) {
        this.appointmentForm.arrivalDate = moment(date).format('YYYY-MM-DD')
        this.preselectTimeSlot = moment(date).format('HH:mm')
      } else {
        this.appointmentForm.arrivalDate = null
        this.preselectTimeSlot = null
      }

      if (this.appointmentForm.staff && this.appointmentForm.arrivalDate) {
        this.loadStaffAvailableTime(this.appointmentForm.arrivalDate)
      }

      this.appointmentForm.sku = ''
      this.appointmentForm.duration = null

      this.appointmentForm.remarks = ''
      // this.appointmentForm.blocked = data['blocked'] ? true : false

      this.appointmentForm.color = this.colorList[0]

      this.appointmentForm.noshowDate = null
      this.appointmentForm.completedDate = null

      this.appointmentForm.reminderTypeID = 0
      
      if (outletID) {
        for (let outlet of this.outlets) {
          if (outlet['id'] === outletID) {
            this.appointmentForm.outlet = outlet
          }
        }
      }

      this.outletSelect(this.appointmentForm.outlet, true)

      this.appointmentForm.staff = ''
      this.appointmentForm.staffName = ''
      this.searchThatStaff = ''

      await this.getStaffList()
      if (staffID) {
        let selectedStaff = this.staffs.find(k => String(k.staffID) === String(staffID))
        if (selectedStaff) {
          this.appointmentForm.staff = selectedStaff
          this.appointmentForm.staffName = selectedStaff.name
          this.searchThatStaff = selectedStaff.name
        }
      }

      this.toggleModal = true
    },

    async getStaffList(forceStaff) {
      let st = await this.$store.state.staffs;
      this.staffs = JSON.parse(st);
      this.staffs = this.staffs.filter(s => {
        if(forceStaff === s['staffID']) {
          return true
        }

        if(s.deleteData) {
          return false
        }
        if(!s.enable) {
          return false
        }
        if(!s.showAppt) {
          return false
        }
        if(s.outletID !== this.appointmentForm.outlet.id) {
          return false
        }
        return true
      });
      // this.staffs = this.staffs.filter(s => s.outletID == this.appointmentForm.outlet.id && s.enable === 1);
      this.staffsClone = JSON.parse(JSON.stringify(this.staffs));
    },
    async getSKUList() {
      let url = "/business/appt";
      let $vm = this;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_MENU,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.skuList = result.skus;
    },
    async getColorList() {
      let url = "/colors";
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$session.get("token") },
      })
        .then((response) => {
          result = response.data.colors.map(k => {
            let temp = this.COLOR_CONST_RAW[k['colorID']]
            if (temp) {
              k['hex'] = temp
            }
            return k
          });
        })
        .catch((err) => {
          console.log(err)
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.colorList = result;
      this.appointmentForm.color = this.colorList[0];
    },
    async getMemberData() {
      let member = await getMemberMap(this)
      // const tx = this.db.transaction("member_list", "readwrite");
      // const store = tx.objectStore("member_list");
      // let res = await store.get("key");
      // res = res.filter((val) => val.deleteDate == 0);
      let res = []
      for (let memberID in member) {
        if (!member[memberID]['deleteDate']) {
          res.push(member[memberID])
          this.memberMobileMap[member[memberID]['mobile']] = member[memberID]
        }
      }
      return res;
    },

    clearForm() {
      this.appointmentForm = {
        outlet: this.appointmentForm.outlet,
        arrivalDate: null,
        time: null,
        staff: null,
        member: {
          name: "",
          mobile: "",
        },
        sku: null,
        color: this.colorList[0],
        blocked: false,
        duration: null,
        remarks: "",
        searchStaff: '',
      };
    },

    selectSku(event) {
      this.appointmentForm.sku = event;
      let index = this.durationList.find((v) => v.value == event.duration);
      this.appointmentForm.duration = index;
    },
    selectDate(event, type) {
      if (type === 1) {
        this.appointmentForm.arrivalDate = event;
      } else {
        this.appointmentForm.time = event;
      }

      this.loadStaffAvailableTime()

      // this.staffs.slice(0, this.staffs.length, ...this.staffsOutletClone);
      // this.staffs = JSON.parse(JSON.stringify(this.staffsOutletClone));
      // this.staffSpinner = true;
      // new Promise((resolve, reject) => {
      //   this.staffs.forEach(async (value, index, array) => {
      //     await this.loadStaffAvailableTime(index, value);
      //     if (index === array.length - 1 || index >= array.length) resolve();
      //   });
      // }).then(() => {
      //   this.staffSpinner = false;
      // });
    },
    selectStaff(s) {
      // if(this.appointmentForm.dataID) {
      //   if(this.appointmentForm.noshowDate || this.appointmentForm.completedDate) {
      //     return
      //   }
      // }

      // this.appointmentForm.staff = s
      // this.searchThatStaff = s.name
      // this.loadStaffAvailableTime(this.appointmentForm.arrivalDate)
    },
    async loadStaffAvailableTime(event) {
      if (!this.appointmentForm.staff || !this.appointmentForm.staff.staffID) {
        return
      }

      if (!this.appointmentForm.arrivalDate) {
        return
      }

      this.timeSpinner = true;
      this.timeSlots = [];
      let result = [];

      let leFormattedDate = moment(this.appointmentForm.arrivalDate).format("DD-MM-YYYY");
      let url =
        this.$api.STAFF +
        "/" +
        this.appointmentForm.staff.staffID +
        "/slots/" +
        leFormattedDate;

      await this
        .$axios({
          method: "get",
          url: url,
          baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
          headers: { token: this.$session.get("token") },
        })
        .then((response) => {
          result = response.data.slots;
        })
        .catch((err) => {
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });

      this.initialLoadTime = false

      result.forEach((element) => {
        element.slotDate = moment.unix(element.slotDate).toDate();
        let hours = element.slotDate.getHours() < 10 ? "0" + element.slotDate.getHours().toString() : element.slotDate.getHours();
        let minutes = element.slotDate.getMinutes() === 0 ? "00" : element.slotDate.getMinutes();
        let formattedTime = `${hours}:${minutes}`;

        if (element.blockDate === 0) {
          this.timeSlots.push(formattedTime);
        } else {
          if (this.appointmentForm.dataID) {
            if (this.appointmentForm.arrivalMoment.format('HH:mm') === formattedTime) {
              this.timeSlots.push(formattedTime);
            }
          }
        }

        if (formattedTime === this.preselectTimeSlot) {
          this.appointmentForm.time = this.preselectTimeSlot
        }
      });

      let quarterHours = ["00", "15", "30", "45"];
      this.timeOptions = [];
      this.timeOptionsClone = []
      for (let i = 0; i < 24; i++) {
        if (this.bookHours.length > 0 && this.bookHours[i].appt != 0) {
          for (let j = 0; j < 4; j++) {
            let fts = (i < 10 ? "0" + i.toString() : i) + ":" + quarterHours[j];

            this.timeOptionsClone.push(fts);

            let gvf = this.timeSlots.find((ts) => ts === fts);
            if (gvf !== undefined) {
              this.timeOptions.push(fts);
            }
          }
        }
      }

      // console.log(this.bookHours)
      // console.log(this.timeSlots)
      // console.log(this.timeOptions)
      // console.log(this.timeOptionsClone)

      this.preselectTimeSlot = null
      this.timeSpinner = false;
    },
    disabledTimeSlot(val) {
      let gvf = this.timeSlots.find((i) => i == val);
      if (gvf === undefined || gvf === null) {
        return false;
      } else {
        return true;
      }
    },
    async outletSelect(sel, dontReset) {
      if (!dontReset) {
        this.searchThatStaff = ''
        this.appointmentForm.staff = null
        this.appointmentForm.staffName = null
        this.appointmentForm.time = null
        this.appointmentForm.sku = null

        await this.getStaffList()
        this.searchStaff(this.searchThatStaff)

        return
      }

      this.timeSpinner = true;
      let url = `https://bebusiness.tunai.io/outlet/${sel.id}/bookhour`;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.hours;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.bookHours = result;
      this.timeSpinner = false;
    },
    searchStaff(val) {
      this.staffs = this.staffsClone.filter((s) => {
        if (!val) {
          return s
        }
        if (s.name.toUpperCase().includes(val.toUpperCase())) {
          return s;
        }
      });
    },

    onPopupSave() {
      if (!this.appointmentForm.dataID) {
        this.openSummaryModal()
      } else {
        this.updateAppt()
      }
    },
    openSummaryModal() {
      this.toggleModalSummary = true
      // this.$refs['appointmentSummaryModal'].show()
    },
    async createAppt() {
      let $vm = this;

      let combinedDate = this.appointmentForm.arrivalDate + " " + this.appointmentForm.time;
      let formattedDate = moment(combinedDate).toDate();
      formattedDate = formattedDate.getTime() / 1000;

      let mbl = this.appointmentForm.member.mobile.charAt(0);
      if (mbl != "6") {
        toastrExe($vm, "New Member", `Number must start with 6 or 65.`, "danger");
        return;
      }

      let url = "https://member.tunai.io/business/member";
      let result = [];
      if (this.addFlag) {
        await this.$axios({
          method: "post",
          url: url,
          headers: { token: this.$session.get("token") },
          data: {
            name: $vm.appointmentForm.member.name,
            mobile: $vm.appointmentForm.member.mobile,
            outletID: $vm.appointmentForm.outlet.id,
          },
        })
          .then(function (response) {
            result = response;
          })
          .catch((err) => {
            result = err.response;
            var errData = err.response.data;
            if (errData.error == this.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });

        if (result.status === 200) {
          toastrExe(
            $vm,
            "New Member",
            `Successfully created member ${$vm.appointmentForm.member.name}`,
            "success"
          );
          this.appointmentForm.member.memberID =
            result.data.members[0].memberID;
        } else {
          toastrExe(
            $vm,
            "New Member",
            `Failed to created member ${$vm.appointmentForm.member.name}`,
            "danger"
          );
        }
      }

      url = "https://appt.tunai.io/business/book";
      await this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
        data: {
          memberID: $vm.appointmentForm.member.memberID,
          outletID: $vm.appointmentForm.outlet.id,
          skuID: $vm.appointmentForm.sku.skuID,
          duration: Number($vm.appointmentForm.duration.value),
          colorID: $vm.appointmentForm.color.colorID,
          blocked: $vm.appointmentForm.blocked ? 1 : 0,
          arrivalDate: formattedDate,
          staffID: $vm.appointmentForm.staff.staffID,
          remarks: $vm.appointmentForm.remarks,
          reminderTypeID: $vm.appointmentForm.reminderTypeID,
        },
      })
        .then((response) => {
          result = response;

          if (result.status === 200) {
            // toastrExe(
            //   $vm,
            //   "New Appointment",
            //   `Successfully created appointment for ${$vm.appointmentForm.member.name}`,
            //   "success"
            // );

            this.toggleModal = false
            this.toggleModalSummary = false

            Swal.fire({
              icon: "success",
              title: "Add Appointment",
              text: `Successfully created appointment for ${$vm.appointmentForm.member.name}`,
            });
            this.$emit("apptCreated", result.data.books[0]);
            this.$bvModal.hide("addAppointmentModalX");
            this.$bvModal.hide("appointmentSummaryModal");
            this.clearForm();
          } else {
            toastrExe(
              $vm,
              "New Appointment",
              `Failed to created appointment for ${$vm.appointmentForm.member.name}. \n${response.data.error || ''}`,
              "danger"
            );
            this.$bvModal.hide("appointmentSummaryModal");
          }
        })
        .catch((err) => {
          console.log(err)
          result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }

          toastrExe(
            $vm,
            "New Appointment",
            `Failed to created appointment for ${$vm.appointmentForm.member.name}. \n${err.response.data.error || ''}`,
            "danger"
          );
        });
    },
    updateAppt() {
      let combinedDate = this.appointmentForm.arrivalDate + " " + this.appointmentForm.time;
      let formattedDate = moment(combinedDate).toDate();
      formattedDate = formattedDate.getTime() / 1000;

      let url = "https://appt.tunai.io/business/book/" + this.appointmentForm.dataID + '/update';

      this.$axios({
        method: "post",
        url: url,
        headers: { token: this.$session.get("token") },
        data: {
          skuID: this.appointmentForm.sku.skuID,
          duration: Number(this.appointmentForm.duration.value),
          colorID: this.appointmentForm.color.colorID,
          blocked: this.appointmentForm.blocked ? 1 : 0,
          arrivalDate: formattedDate,
          staffID: this.appointmentForm.staff.staffID,
          remarks: this.appointmentForm.remarks,
          reminderTypeID: this.appointmentForm.reminderTypeID,
        },
      })
        .then((response) => {
          let result = response;

          if (result.status === 200) {
            this.toggleModal = false
            this.toggleModalSummary = false

            Swal.fire({
              icon: "success",
              title: "Update Appointment",
              text: `Successfully update appointment for ${this.appointmentForm.member.name}`,
            });

            this.$emit("apptCreated", result.data.books[0]);
            this.$bvModal.hide("addAppointmentModalX");
            this.$bvModal.hide("appointmentSummaryModal");
            this.clearForm();
          } else {
            toastrExe(
              this,
              "Update Appointment",
              `Failed to update appointment for ${this.appointmentForm.member.name}. \n${response.data.error || ''}`,
              "danger"
            );
            this.$bvModal.hide("appointmentSummaryModal");
          }
        })
        .catch((err) => {
          console.log(err)
          let result = err.response;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }

          toastrExe(
            this,
            "Update Appointment",
            `Failed to update appointment for ${this.appointmentForm.member.name}. \n${err.response.data.error || ''}`,
            "danger"
          );
        });
    },

    async emitDetail(bookID, operation) {
      let flag = false;
      let text = "";
      if (operation === 'noshow')
        text = "'no show'"
      else if (operation === 'completed')
        text = "complete"
      else if (operation === 'delete')
        text = "delete"
      else if (operation === 'blocked')
        text = "block"

      await Swal.fire({
        title: `Confirm ${text} appointment?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });

      if (!flag) {
        return;
      }

      let $vm = this;
      var result = {};
      await $vm
        .$axios({
          method: "post",
          url: "https://appt.tunai.io/business/book/" + bookID + "/" + operation,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Appointment Update",
            text: operation == "delete"
              ? `Book ID:${bookID} has been deleted`
              : `Update for Book ID:${bookID} Successful`,
          });

          this.toggleModal = false
          this.toggleModalSummary = false

          this.$emit("apptCreated");
        })
        .catch((err) => {
          console.log(err)
          Swal.fire({
            icon: "error",
            title: "Appointment Update",
            text: `Update for Book ID:${bookID} Failed`,
          });

          result = err.response;
          var errData = err.response?.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
    },


    async onMemberTag(event) {
      this.manualFlag = true
      this.addFlag = true;

      if (event.charAt(0) != "6") {
        event = "6" + event;
      }

      if (event.charAt(0) == '6' && event.charAt(1) == '0') {
        if (event.length > 12) {
          this.maxCharLimit = true;
        } else {
          this.maxCharLimit = false;
        }
      } else if (event.charAt(0) == '6' && event.charAt(1) == '5') {
        if (event.length > 10) {
          this.maxCharLimit = true;
        }
        else {
          this.maxCharLimit = false;
        }
      }

      this.appointmentForm.member = {
        mobile: event,
        name: "",
      };

      let temp = []
      for(let member of this.members) {
        if(!member.tag) {
          temp.push(member)
        }
      }

      if(event) {
        let match = this.memberMobileMap[event]
        if(match) {
          this.appointmentForm.member = match
        } else {
          // temp.push({
          //   mobile: event,
          //   name: this.appointmentForm.member.name === '' ? this.appointmentForm.member.mobile : this.appointmentForm.member.name,
          //   tag: true,
          // });
        }
      }

      this.members = temp
    },
    onMemberSelect(event) {
      this.manualFlag = true
      this.addFlag = false;
      this.appointmentForm.member = event;
    },
    onMemberOpen() {
      let saved = localStorage.getItem('appointment-member')
      if(!this.$refs['member-input'].search) {
        this.$refs['member-input'].search = saved ? saved : '6'
      }
    },
    onMemberClose() {
      if(!this.manualFlag && this.lastInput) {
        this.onMemberTag(this.lastInput)
      }

      let mobile = this.appointmentForm.member.mobile
      if (mobile.startsWith('60')) {
        localStorage.setItem('appointment-member', '60')
      } else if (mobile.startsWith('65')) {
        localStorage.setItem('appointment-member', '65')
      }
    },
    onMemberInput() {
      this.manualFlag = false
      if(this.$refs['member-input'].search) {
        this.lastInput = this.$refs['member-input'].search
      }
    },
  },
  async created() {
    this.outlets = JSON.parse(await this.$store.state.outlets);
    this.appointmentForm.outlet = this.outlets[0];
    // let dbName = this.$store.state.userName + "_memberList";
    // this.db = await idbOpen(dbName, "member_list");
    this.members = await this.getMemberData();
    await this.getColorList();
    await this.getSKUList();
    // await this.getStaffList();
  },
  computed: {
    minDate() {
      let now = moment().format("YYYY-MM-DD");
      return now;
    },
    combineDateTime() {
      let combinedDate = this.appointmentForm.arrivalDate + " " + this.appointmentForm.time;
      let formattedDate = moment(combinedDate).format("DD MMM YYYY hh:mm a");
      return formattedDate;
    },
    durationList() {
      let options = []
      let duration = 15

      do {
        let text = ''
        let hour = Math.floor(duration / 60)
        if (hour) {
          text += hour + ' Hour' + (hour > 1 ? 's' : '')
        }
        let minute = duration % 60
        if (minute) {
          text += text ? ' ' : text
          text += minute + ' Minutes'
        }

        options.push({ value: duration, text: text })

        duration += 15
      } while (duration < (10 * 60))

      return options
    },
    saveable() {
      let form = this.appointmentForm;
      let flag = false;
      if (
        form.member.mobile === "" ||
        form.member.name === "" ||
        form.arrivalDate === null ||
        form.time === null ||
        form.staff === null ||
        form.sku === null ||
        form.duration === null ||
        form.color === null
      ) {
        flag = true;
      }

      if(contactValidation(this.appointmentForm.member.mobile)) {
        flag = true
      }

      return flag;
    },
  },
};
</script>
<style scoped>
#addAppointmentModalX___BV_modal_content_ {
  border-radius: 0.7rem;
}

.btn-staff {
  color: black !important;
  background-color: #eaebeb !important;
  border-color: #eaebeb !important;
  box-shadow: none !important;
}

.btn-staff.active {
  color: white !important;
  background-color: #886ab5 !important;
  border-color: #886ab5 !important;
}

.btn-staff:hover {
  color: white !important;
  background-color: #886ab5 !important;
  border-color: #886ab5 !important;
}

.boxColor {
  height: 40px;
  min-width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: white !important; */
}

.popover-body {
  padding: 0 !important;
}

.b-popover {
  max-width: 700px !important;
}

#appointment-datepicker__dialog_ {
  display: none !important;
}

#appointment-datepicker__dialog_.show {
  display: block !important;
}

.modal-body {
  max-height: 65vh;
  overflow-y: auto;
}

.show {
  display: block;
}

.modal-lg {
  max-width: 1000px;
}
</style>